import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { reconcileBrazeIdentity } from '../../utils/braze';

export const useBrazeIdentityReconcile = () => {
    const memberId = useSelector((state) => state.auth?.user?.id);

    useEffect(() => {
        reconcileBrazeIdentity(memberId);
    }, [memberId]);
};
